import { __assign, __extends } from "tslib";
import React from 'react';
import { MediaClient } from '../client/media-client';
var mediaClientsMap = new Map();
export var getMediaClient = function (mediaClientConfig) {
    var mediaClient = mediaClientsMap.get(mediaClientConfig);
    if (!mediaClient) {
        mediaClient = new MediaClient(mediaClientConfig);
        mediaClientsMap.set(mediaClientConfig, mediaClient);
    }
    return mediaClient;
};
var createEmptyMediaClient = function () {
    var emptyConfig = {
        authProvider: function () {
            return Promise.resolve({
                clientId: '',
                token: '',
                baseUrl: '',
            });
        },
    };
    return new MediaClient(emptyConfig);
};
export var withMediaClient = function (Component) {
    return /** @class */ (function (_super) {
        __extends(class_1, _super);
        function class_1() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        class_1.prototype.render = function () {
            // TODO MS-1552: clean up after we move mediaClientConfig into FileIdentifier
            var props = this.props;
            var mediaClientConfig = props.mediaClientConfig, identifier = props.identifier;
            var isExternalIdentifier = identifier && identifier.mediaItemType === 'external-image';
            var mediaClient = isExternalIdentifier
                ? createEmptyMediaClient()
                : getMediaClient(mediaClientConfig);
            return React.createElement(Component, __assign({}, props, { mediaClient: mediaClient }));
        };
        return class_1;
    }(React.Component));
};
//# sourceMappingURL=with-media-client-hoc.js.map